import icon0 from './construction--barrier--temporary.png';
import icon1 from './construction--flat--crosswalk-plain.png';
import icon2 from './construction--flat--driveway.png';
import icon3 from './construction--flat--flat-driveway.png';
import icon4 from './marking--discrete--arrow--left.png';
import icon5 from './marking--discrete--arrow--right.png';
import icon6 from './marking--discrete--arrow--split-left-or-straight.png';
import icon7 from './marking--discrete--arrow--split-right-or-straight.png';
import icon8 from './marking--discrete--arrow--straight.png';
import icon9 from './marking--discrete--crosswalk-zebra.png';
import icon10 from './marking--discrete--give-way-row.png';
import icon11 from './marking--discrete--give-way-single.png';
import icon12 from './marking--discrete--other-marking.png';
import icon13 from './marking--discrete--stop-line.png';
import icon14 from './marking--discrete--symbol--bicycle.png';
import icon15 from './marking--discrete--text.png';
import icon16 from './object--banner.png';
import icon17 from './object--bench.png';
import icon18 from './object--bike-rack.png';
import icon19 from './object--catch-basin.png';
import icon20 from './object--cctv-camera.png';
import icon21 from './object--fire-hydrant.png';
import icon22 from './object--junction-box.png';
import icon23 from './object--mailbox.png';
import icon24 from './object--manhole.png';
import icon25 from './object--parking-meter.png';
import icon26 from './object--phone-booth.png';
import icon27 from './object--sign--advertisement.png';
import icon28 from './object--sign--information.png';
import icon29 from './object--sign--store.png';
import icon30 from './object--street-light.png';
import icon31 from './object--support--pole.png';
import icon32 from './object--support--traffic-sign-frame.png';
import icon33 from './object--support--utility-pole.png';
import icon34 from './object--traffic-cone.png';
import icon35 from './object--traffic-light.png';
import icon36 from './object--trash-can.png';
import icon37 from './object--water-valve.png';

const textures = {
  'construction--barrier--temporary': icon0,
  'construction--flat--crosswalk-plain': icon1,
  'construction--flat--driveway': icon2,
  'construction--flat--flat-driveway': icon3,
  'marking--discrete--arrow--left': icon4,
  'marking--discrete--arrow--right': icon5,
  'marking--discrete--arrow--split-left-or-straight': icon6,
  'marking--discrete--arrow--split-right-or-straight': icon7,
  'marking--discrete--arrow--straight': icon8,
  'marking--discrete--crosswalk-zebra': icon9,
  'marking--discrete--give-way-row': icon10,
  'marking--discrete--give-way-single': icon11,
  'marking--discrete--other-marking': icon12,
  'marking--discrete--stop-line': icon13,
  'marking--discrete--symbol--bicycle': icon14,
  'marking--discrete--text': icon15,
  'object--banner': icon16,
  'object--bench': icon17,
  'object--bike-rack': icon18,
  'object--catch-basin': icon19,
  'object--cctv-camera': icon20,
  'object--fire-hydrant': icon21,
  'object--junction-box': icon22,
  'object--mailbox': icon23,
  'object--manhole': icon24,
  'object--parking-meter': icon25,
  'object--phone-booth': icon26,
  'object--sign--advertisement': icon27,
  'object--sign--information': icon28,
  'object--sign--store': icon29,
  'object--street-light': icon30,
  'object--support--pole': icon31,
  'object--support--traffic-sign-frame': icon32,
  'object--support--utility-pole': icon33,
  'object--traffic-cone': icon34,
  'object--traffic-light': icon35,
  'object--trash-can': icon36,
  'object--water-valve': icon37,
};

export default textures;